<template>
  <div>
    <section class="small-12 medium-12 large-12 columns">
      <h1 v-html="vueModel.ContentViewModel.Step3VacationHouse.StepTitle" />
      <article>
        <scalepoint
          v-model="vueModel.CreateClaimEntity.ProductSpecific.ScalePointEntity"
          :scalepoint-view-model="stepModel.ProductSpecific.ScalepointViewModel"
          :tracking-vm="trackingVm"
        />
      </article>
    </section>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import ReportClaimMixin from '../ReportClaimMixin.vue';
import Scalepoint from '../../components/Scalepoint.vue';

export default {
  name: 'ReportClaimVacationHouseStep3',
  components: {
    Scalepoint
  },
  mixins: [ReportClaimMixin],
  props: {
    vueModel: {
      type: Object,
      default() {
        return {};
      }
    },
    trackingVm: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      stepModel: this.vueModel.CreateClaimStep3Model
    };
  },
  created() {
    window.widgetOptions = {
      saveCallback() {
        // console.log('saved', data);
      },
      submitCallback() {
        // console.log('Thank you for SUBMITTING', a, b, c);
      }
    };
    var scriptElm = document.createElement('script');
    scriptElm.setAttribute(
      'src',
      this.stepModel.ProductSpecific.ScalepointViewModel.ScalepointWidgetUrl
    );
    document.body.appendChild(scriptElm);
  },
  beforeUnmount() {
    if (this.vueModel.CreateClaimEntity.ProductSpecific.ScalepointViewModel !== undefined) {
      return;
    }
    // Can this be explained a bit - so we know in 3 years from now, why are these just set when destroy object.....

    this.vueModel.CreateClaimEntity.ProductSpecific.ScalepointTokenCase =
      this.stepModel.ProductSpecific.ScalepointViewModel.ScalepointTokenCase;

    this.vueModel.CreateClaimEntity.ProductSpecific.ScalepointTokenSso =
      this.stepModel.ProductSpecific.ScalepointViewModel.ScalepointTokenSso;
  }
};
</script>
